<template>
  <div class="header-notification">
    <div class="header-notification-indicator" @click="showList()">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path d="M3.45549 12.88L2.83197 12.3503H2.83197L3.45549 12.88ZM4.33476 10.8385L3.52178 10.7464L4.33476 10.8385ZM17.6652 10.8385L18.4782 10.7464V10.7464L17.6652 10.8385ZM18.5445 12.88L19.168 12.3503L18.5445 12.88ZM17.3204 7.79403L16.5074 7.88613V7.88613L17.3204 7.79403ZM4.67964 7.79403L5.49262 7.88613L4.67964 7.79403ZM14.7661 18.2871C14.9247 17.864 14.7103 17.3924 14.2871 17.2339C13.864 17.0753 13.3924 17.2897 13.2339 17.7129L14.7661 18.2871ZM8.76614 17.7129C8.60757 17.2897 8.136 17.0753 7.71287 17.2339C7.28974 17.3924 7.07528 17.864 7.23386 18.2871L8.76614 17.7129ZM17.1699 15.1818H4.83014V16.8182H17.1699V15.1818ZM16.5074 7.88613L16.8523 10.9306L18.4782 10.7464L18.1333 7.70194L16.5074 7.88613ZM5.14774 10.9306L5.49262 7.88613L3.86665 7.70194L3.52178 10.7464L5.14774 10.9306ZM4.07902 13.4098C4.67257 12.7112 5.04399 11.8464 5.14774 10.9306L3.52178 10.7464C3.45413 11.3435 3.21236 11.9026 2.83197 12.3503L4.07902 13.4098ZM16.8523 10.9306C16.956 11.8464 17.3274 12.7112 17.921 13.4098L19.168 12.3503C18.7876 11.9026 18.5459 11.3435 18.4782 10.7464L16.8523 10.9306ZM4.83014 15.1818C4.00539 15.1818 3.46627 14.131 4.07902 13.4098L2.83197 12.3503C1.3779 14.0618 2.51623 16.8182 4.83014 16.8182V15.1818ZM17.1699 16.8182C19.4838 16.8182 20.6221 14.0618 19.168 12.3503L17.921 13.4098C18.5337 14.131 17.9946 15.1818 17.1699 15.1818V16.8182ZM18.1333 7.70194C17.7145 4.00417 14.6641 1.18182 11 1.18182V2.81818C13.794 2.81818 16.1779 4.97754 16.5074 7.88613L18.1333 7.70194ZM5.49262 7.88613C5.8221 4.97754 8.20603 2.81818 11 2.81818V1.18182C7.33586 1.18182 4.28554 4.00417 3.86665 7.70194L5.49262 7.88613ZM13.2339 17.7129C12.9215 18.5463 12.0573 19.1818 11 19.1818V20.8182C12.7128 20.8182 14.2051 19.7841 14.7661 18.2871L13.2339 17.7129ZM11 19.1818C9.94273 19.1818 9.0785 18.5463 8.76614 17.7129L7.23386 18.2871C7.79487 19.7841 9.28721 20.8182 11 20.8182V19.1818Z" fill="#222222"/>
      </svg>
      <div class="counter-indicator">
        <span class="value">{{hn_qnt}}</span>
      </div>
    </div>
    <div class="notification-list" v-if="show_list">
      <div class="head">
        <h3 class="title">Уведомления</h3>
        <div class="close" @click="closeList()">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path d="M18.9498 9.05023L9.05029 18.9497M18.9498 18.9497L9.05029 9.05017" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
      <div class="body">
        <div class="wtf">
          <div class="item">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M3 3H21" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8 9H16" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M3 15H21" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8 21H16" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="item">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M2 13L5.52642 15.8211C6.35374 16.483 7.55365 16.3848 8.2624 15.5973L16 7M8 13L11.5264 15.8211C12.3537 16.483 13.5536 16.3848 14.2624 15.5973L22 7" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
        <div class="items">
          <template v-for="notification in notificationData" :key="notification">
            <div class="item" @click="setNotificationAsRead(notification)">
              <div class="icon">
                <img :src="icons[notification.type]">
              </div>
              <div class="content">
                <div class="title">
                  <span>{{notification.title}}</span>
                  <svg v-show="!notification.read" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                    <circle cx="3" cy="3" r="3" fill="#FA4B61"/>
                  </svg>
                </div>
                <div class="text" v-show="notification.text != ''">
                  {{notification.text}}
                </div>
                <div class="date_time">
                  <div class="date">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
                      <path d="M14 1.66675V3.33341M4 1.66675V3.33341" stroke="#1B78BC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M8.9961 10.8335H9.00358M8.9961 14.1668H9.00358M12.3257 10.8335H12.3332M5.6665 10.8335H5.67398M5.6665 14.1668H5.67398" stroke="#1B78BC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M1.9165 6.66675H16.0832" stroke="#1B78BC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M1.08325 10.2027C1.08325 6.57161 1.08325 4.75607 2.12668 3.62803C3.17012 2.5 4.84949 2.5 8.20825 2.5H9.79158C13.1503 2.5 14.8297 2.5 15.8732 3.62803C16.9166 4.75607 16.9166 6.57161 16.9166 10.2027V10.6306C16.9166 14.2617 16.9166 16.0773 15.8732 17.2053C14.8297 18.3333 13.1503 18.3333 9.79158 18.3333H8.20825C4.84949 18.3333 3.17012 18.3333 2.12668 17.2053C1.08325 16.0773 1.08325 14.2617 1.08325 10.6306V10.2027Z" stroke="#1B78BC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M1.5 6.66675H16.5" stroke="#1B78BC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>{{notification.date}}</span>
                  </div>
                  <div class="time">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <circle cx="10.0001" cy="10.0001" r="8.33333" stroke="#1B78BC" stroke-width="1.5"/>
                      <path d="M7.91675 7.91675L10.8333 10.8331M13.3334 6.66675L9.16675 10.8334" stroke="#1B78BC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>{{notification.time}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="sep"></div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from "axios";

export default {
  name: 'HeaderNotification',
  props : {
    hn_qnt: Number,
    notificationData: Array
  },
  components: {

  },
  data() {
    return{
      show_list : false,
      icons : {
        order : require('@/assets/notifications/basket.svg'),
        personal : require('@/assets/notifications/personal.svg'),
        security : require('@/assets/notifications/lock.svg'),
        location : require('@/assets/notifications/location.svg'),
        bill : require('@/assets/notifications/bill.svg'),
        promo : require('@/assets/notifications/sale.svg')
      },
    }
  },
  mounted() {

  },
  methods : {
    showList : function() {
      this.show_list = true;
    },
    closeList : function() {
      this.show_list = false;
    },
    setNotificationAsRead: async function(notification) {
      await axios.get(window.api_url + "main/set_noti_as_read?id="+notification.id+"&api=y&auth=IUgioufdoifopowuntyywocjroiOEREOHFihfuiwei");
      notification.read = true;

      this.$emit("notifications_changed");
    }
  }
}
</script>

<style scoped>

.header-notification-indicator {
  display: flex;
  cursor: pointer;
  position: relative;
}

.counter-indicator {
  position: absolute;
  top: -9px;
  right: -9px;
  height: 19px;
  width: 19px;
  background: var(--Blue, #1B78BC);
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--White, #FFF);
}

.counter-indicator .value{
  color: var(--White, #FFF);
  text-align: center;
  leading-trim: both;
  text-edge: cap;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.notification-list {
  width: 482px;
  height: 100vh;
  padding: 30px;
  position: fixed;
  background: var(--White);
  z-index: 10;
  top: 0px;
  right: 0px;
  box-sizing: border-box;
  border-left: 1px solid var(--Border);
  box-shadow: 0px 6px 50px 0px rgba(0, 0, 0, 0.10);
}

.notification-list .head {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.notification-list .head .title {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  margin: 0px;
}

.notification-list .head .close {
  width: 40px;
  height: 40px;
  border-radius: 100px;
  border: 1px solid var(--Gray, #656565);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.notification-list .body {

}

.notification-list .body .wtf {
  padding-bottom: 14px;
  border-bottom: 1px solid var(--Border, #EDEDED);
  display: flex;
  gap: 10px;
}

.notification-list .body .wtf .item {
  padding: 7px;
  display: flex;
}

.notification-list .body .items {
  overflow: auto;
  height: calc(100vh - 185px);
  margin: 0px -30px;
}

.notification-list .body .items .item {
  padding: 18px 30px;
  display: flex;
  gap: 14px;
}

.notification-list .body .items .item:hover {
  background: var(--BG, #F8F8F8);
}

.notification-list .body .items .item:hover .icon{
  background: var(--White);
}

.notification-list .body .items .item .icon {
  height: 50px;
  width: 50px;
  box-sizing: border-box;
  border-radius: 100px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--BG, #F8F8F8);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.notification-list .body .items .item .content {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 6px;
  flex: 1;
}

.notification-list .body .items .item .content .title {

}

.notification-list .body .items .item .content .title svg {
  margin-left: 8px;
  margin-bottom: 3px;
}

.notification-list .body .items .item .content .title span {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  cursor: pointer;
}

.notification-list .body .items .item .content .text {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  padding-bottom: 2px;
}

.notification-list .body .items .item .content .date_time {
  display: flex;
  gap: 20px;
  align-items: center;
}

.notification-list .body .items .item .content .date_time .date,
.notification-list .body .items .item .content .date_time .time {
  gap: 6px;
  display: flex;
  align-items: center;
}

.notification-list .body .items .item .content .date_time span {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.notification-list .body .items .sep {
  height: 1px;
  width: calc(100% - 60px);
  background: var(--Border);
  margin: 0px 30px;
}



.notification-list .body .items::-webkit-scrollbar {
  width: 3px; /* Ширина всего элемента навигации */
}

.notification-list .body .items::-webkit-scrollbar-track {
  background: #fff; /* Цвет дорожки */
}

.notification-list .body .items::-webkit-scrollbar-thumb {
  background: var(--Gray, #656565); /* Цвет бегунка */
  border-radius: 20px; /* Округление бегунка */
  border: 3px solid var(--Border, #EDEDED); /* Оформление границ бегунка */
}

/*MOBILE*/
@media (max-width: 1250px)
{
  .notification-list {
    width: 100%;
    padding: 24px 15px;
  }
}

</style>



<style>




/*MOBILE*/
@media (max-width: 1250px)
{

}

</style>